(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hmc-contact-form"] && !Shopify.designMode) return;
  try {
    
  class HmcContactForm extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      const section = this.closest('.hmc-contact-form');
      const textarea = this.querySelector('[data-hmc-contact-message]');
      const counter = this.querySelector('[data-hmc-contact-counter]');

      if (!textarea || !counter || !section) return;

      const max = Number.parseInt(
        getComputedStyle(section).getPropertyValue('--hmc-contact-max-length') || textarea.maxLength,
        10
      );

      const updateCount = () => {
        const count = textarea.value.length;
        counter.textContent = `${count} of ${max}`;
      };

      textarea.addEventListener('input', updateCount, { signal });
      updateCount();
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }
  }

  if (!customElements.get('hmc-contact-form')) {
    customElements.define('hmc-contact-form', HmcContactForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hmc-product"] && !Shopify.designMode) return;
  try {
    
  class HmcProductSection extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      const variants = JSON.parse(this.querySelector('[data-hmc-product-json]')?.textContent || '[]');
      const variantInput = this.querySelector('[data-hmc-product-variant-id]');
      const variantSelect = this.querySelector('[data-hmc-product-variant-select]');
      const optionSelects = this.querySelectorAll('[data-hmc-product-option]');
      const priceEl = this.querySelector('[data-hmc-product-price]');
      const stockEl = this.querySelector('[data-hmc-product-stock]');
      const submitBtn = this.querySelector('[data-hmc-product-submit]');
      const featuredImage = this.querySelector('[data-hmc-product-featured-image]');
      const thumbs = this.querySelectorAll('[data-hmc-product-thumb]');

      const labels = {
        inStock: this.dataset.labelInStock || 'In stock',
        outOfStock: this.dataset.labelOutOfStock || 'Out of stock',
        addToCart: this.dataset.labelAddToCart || 'Add to cart',
        soldOut: this.dataset.labelSoldOut || 'Sold out',
        priceLabel: this.dataset.priceLabel || 'Price: [price]'
      };

      const formatMoney = (cents) => {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents);
        }
        return `$${(cents / 100).toFixed(2)}`;
      };

      const findVariantByOptions = () => {
        const selected = Array.from(optionSelects).map((select) => select.value);
        return variants.find((variant) =>
          variant.options.every((option, index) => option === selected[index])
        );
      };

      const updateVariant = (variant) => {
        if (!variant || !variantInput) return;

        variantInput.value = variant.id;

        if (priceEl) {
          if (variant.price > 0) {
            priceEl.style.display = '';
            const formattedPrice = formatMoney(variant.price);
            const compare = variant.compare_at_price > variant.price
              ? `<span class="hmc-product__price-compare" aria-hidden="true">${formatMoney(variant.compare_at_price)}</span>`
              : '';
            priceEl.innerHTML = `${compare}<span class="hmc-product__price-current">${formattedPrice}</span>`;
            priceEl.setAttribute('aria-label', labels.priceLabel.replace('[price]', formattedPrice));
          } else {
            priceEl.style.display = 'none';
          }
        }

        if (stockEl) {
          stockEl.textContent = variant.available ? labels.inStock : labels.outOfStock;
          stockEl.classList.toggle('hmc-product__stock--in', variant.available);
          stockEl.classList.toggle('hmc-product__stock--out', !variant.available);
        }

        const notifyWrap = document.querySelector('[data-notify-wrap]');
        if (notifyWrap) notifyWrap.hidden = !!variant.available;

        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          const submitLabel = submitBtn.querySelector('span') || submitBtn;
          submitLabel.textContent = variant.available ? labels.addToCart : labels.soldOut;
        }
      };

      if (priceEl) {
        const checkPriceVisibility = () => {
          const currentPriceSpan = priceEl.querySelector('.hmc-product__price-current') || priceEl;
          const text = currentPriceSpan.textContent || '';
          const numericMatch = text.replace(/[^0-9.]/g, '');
          const priceValue = parseFloat(numericMatch);
          if (isNaN(priceValue) || priceValue <= 0) {
            priceEl.style.display = 'none';
          } else {
            priceEl.style.display = '';
          }
        };

        const priceObserver = new MutationObserver(() => {
          checkPriceVisibility();
        });
        priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
        signal.addEventListener('abort', () => priceObserver.disconnect());
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          const variant = variants.find((item) => String(item.id) === variantSelect.value);
          updateVariant(variant);
        }, { signal });
      }

      for (const select of optionSelects) {
        select.addEventListener('change', () => {
          updateVariant(findVariantByOptions());
        }, { signal });
      }

      for (const thumb of thumbs) {
        thumb.addEventListener('click', () => {
          if (!featuredImage) return;

          featuredImage.src = thumb.dataset.src;
          if (thumb.dataset.srcset) {
            featuredImage.srcset = thumb.dataset.srcset;
          }

          for (const button of thumbs) {
            const isActive = button === thumb;
            button.classList.toggle('hmc-product__thumb--active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        }, { signal });
      }
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }
  }

  if (!customElements.get('hmc-product-section')) {
    customElements.define('hmc-product-section', HmcProductSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hmc-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.__hmcReviewMore) {
    window.__hmcReviewMore = true;
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-review-more]');
      if (!b) return;
      const box = b.closest('[data-review-text]');
      const open = box.classList.toggle('is-open');
      b.textContent = open ? 'Show Less' : 'Read More';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    const refine = () => document.querySelectorAll('[data-review-text]').forEach((box) => {
      const body = box.querySelector('.hmc-reviews__body'); const b = box.querySelector('[data-review-more]');
      if (!body || !b || box.classList.contains('is-open') || !body.clientHeight) return;
      b.hidden = body.scrollHeight <= body.clientHeight + 1;
    });
    window.addEventListener('load', refine); window.addEventListener('resize', refine);
    document.addEventListener('toggle', refine, true); document.addEventListener('click', () => setTimeout(refine, 50));
  }
  if (!customElements.get('hmc-reviews-ui')) {
    class HmcReviewsUi extends HTMLElement {
      #controller = null;
      #timer = null;
      #index = 0;
      #paused = false;
      #uniqueCount = 0;
      #resizeObserver = null;

      connectedCallback() {
        this.#controller = new AbortController();
        const { signal } = this.#controller;

        this.track = this.querySelector('[data-reviews-track]');
        this.viewport = this.querySelector('[data-reviews-viewport]');
        this.dots = [...this.querySelectorAll('[data-reviews-dot]')];
        this.pauseButton = this.querySelector('[data-reviews-pause]');
        this.modal = this.querySelector('[data-reviews-modal]');
        this.openButton = this.querySelector('[data-reviews-open]');

        this.#initSlider(signal);
        this.#initModal(signal);
      }

      disconnectedCallback() {
        this.#stop();
        this.#controller?.abort();
        this.#resizeObserver?.disconnect();
      }

      #perView() {
        return window.matchMedia('(min-width: 750px)').matches ? 3 : 1;
      }

      #reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      #initSlider(signal) {
        if (!this.track || !this.viewport) return;

        this.originalSlides = [...this.track.querySelectorAll('[data-review-slide]')];
        this.#uniqueCount = this.originalSlides.length;
        if (this.#uniqueCount < 2) {
          this.pauseButton?.setAttribute('hidden', '');
          return;
        }

        this.#prepareClones();
        this.track.classList.add('is-ready');
        this.#goTo(0, false);

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.#goTo(index);
            this.#restart();
          }, { signal });
        });

        this.pauseButton?.addEventListener('click', () => {
          this.#paused = !this.#paused;
          this.pauseButton.setAttribute('aria-pressed', this.#paused ? 'true' : 'false');
          const playLabel = this.pauseButton.dataset.labelPlay || 'Play slideshow';
          const pauseLabel = this.pauseButton.dataset.labelPause || 'Pause slideshow';
          this.pauseButton.setAttribute('aria-label', this.#paused ? playLabel : pauseLabel);
          if (this.#paused) this.#stop();
          else this.#start();
        }, { signal });

        this.viewport.addEventListener('mouseenter', () => this.#stop(), { signal });
        this.viewport.addEventListener('mouseleave', () => {
          if (!this.#paused) this.#start();
        }, { signal });
        this.viewport.addEventListener('focusin', () => this.#stop(), { signal });
        this.viewport.addEventListener('focusout', () => {
          if (!this.#paused) this.#start();
        }, { signal });

        this.track.addEventListener('transitionend', () => this.#onTransitionEnd(), { signal });

        this.#resizeObserver = new ResizeObserver(() => {
          const real = this.#index % this.#uniqueCount;
          this.#prepareClones();
          this.#goTo(real, false);
        });
        this.#resizeObserver.observe(this.viewport);

        if (!this.#reducedMotion()) this.#start();
        else {
          this.#paused = true;
          this.pauseButton?.setAttribute('aria-pressed', 'true');
        }
      }

      #prepareClones() {
        this.track.querySelectorAll('[data-review-clone]').forEach((node) => node.remove());
        const perView = this.#perView();
        const clones = this.originalSlides.slice(0, perView);
        for (const slide of clones) {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-review-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('role');
          this.track.appendChild(clone);
        }
      }

      #slideOffset() {
        const first = this.track.querySelector('[data-review-slide]');
        if (!first) return 0;
        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      #goTo(index, animate = true) {
        if (!this.track) return;
        if (!animate) this.track.classList.remove('is-ready');
        this.#index = index;
        const offset = this.#slideOffset() * this.#index;
        this.track.style.transform = `translateX(-${offset}px)`;
        this.#updateDots();
        this.#updateLive();
        if (!animate) {
          this.track.offsetHeight;
          this.track.classList.add('is-ready');
        }
      }

      #onTransitionEnd() {
        if (this.#index < this.#uniqueCount) return;
        this.#goTo(this.#index % this.#uniqueCount, false);
      }

      #next() {
        this.#goTo(this.#index + 1);
      }

      #updateDots() {
        const active = ((this.#index % this.#uniqueCount) + this.#uniqueCount) % this.#uniqueCount;
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('hmc-reviews__dot--active', index === active);
        });
      }

      #updateLive() {
        const slides = [...this.track.querySelectorAll('[data-review-slide]:not([data-review-clone])')];
        const start = ((this.#index % this.#uniqueCount) + this.#uniqueCount) % this.#uniqueCount;
        const perView = this.#perView();
        slides.forEach((slide, index) => {
          let visible = false;
          for (let offset = 0; offset < perView; offset += 1) {
            if ((start + offset) % this.#uniqueCount === index) visible = true;
          }
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }

      #start() {
        this.#stop();
        if (this.#paused || this.#reducedMotion() || this.#uniqueCount < 2) return;
        this.#timer = window.setInterval(() => this.#next(), 5000);
      }

      #stop() {
        if (this.#timer) {
          window.clearInterval(this.#timer);
          this.#timer = null;
        }
      }

      #restart() {
        if (!this.#paused) this.#start();
      }

      #initModal(signal) {
        if (!this.modal || !this.openButton) return;

        const closeButton = this.modal.querySelector('[data-reviews-close]');
        const form = this.modal.querySelector('[data-reviews-form]');
        const search = this.modal.querySelector('[data-reviews-search]');
        const sort = this.modal.querySelector('[data-reviews-sort]');
        const rating = this.modal.querySelector('[data-reviews-rating]');
        const category = this.modal.querySelector('[data-reviews-category]');
        const list = this.modal.querySelector('[data-reviews-modal-list]');
        const empty = this.modal.querySelector('[data-reviews-empty]');
        const cards = list ? [...list.querySelectorAll('.hmc-reviews__item')] : [];

        const applyFilters = () => {
          const query = (search?.value || '').trim().toLowerCase();
          const sortBy = sort?.value || 'recent';
          const ratingValue = rating?.value || 'all';
          const categoryValue = category?.value || 'all';

          const visible = cards.filter((card) => {
            const haystack = [
              card.dataset.reviewAuthor,
              card.dataset.reviewBody,
              card.dataset.reviewDate,
            ]
              .join(' ')
              .toLowerCase();
            const matchesQuery = query === '' || haystack.includes(query);
            const cardRating = Number.parseFloat(card.dataset.reviewRating || '5');
            const matchesRating =
              ratingValue === 'all' || Math.round(cardRating) === Number.parseInt(ratingValue, 10);
            const matchesCategory =
              categoryValue === 'all' ||
              (card.dataset.reviewCategory || 'knives').toLowerCase() === categoryValue;
            card.hidden = !(matchesQuery && matchesRating && matchesCategory);
            return !card.hidden;
          });

          visible.sort((a, b) => {
            if (sortBy === 'rated') {
              return (
                Number.parseFloat(b.dataset.reviewRating || '0') -
                Number.parseFloat(a.dataset.reviewRating || '0')
              );
            }
            if (sortBy === 'useful') {
              return (b.dataset.reviewBody || '').length - (a.dataset.reviewBody || '').length;
            }
            const dateA = Date.parse(a.dataset.reviewDate || '') || 0;
            const dateB = Date.parse(b.dataset.reviewDate || '') || 0;
            return dateB - dateA;
          });

          for (const card of visible) list.appendChild(card);

          if (empty) empty.hidden = visible.length > 0;
        };

        this.openButton.addEventListener('click', () => {
          this.#stop();
          applyFilters();
          this.modal.showModal();
          this.openButton.setAttribute('aria-expanded', 'true');
          search?.focus();
        }, { signal });

        closeButton?.addEventListener('click', () => this.modal.close(), { signal });
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.modal.close();
        }, { signal });
        this.modal.addEventListener('close', () => {
          this.openButton.setAttribute('aria-expanded', 'false');
          this.openButton.focus();
          if (!this.#paused) this.#start();
        }, { signal });

        form?.addEventListener('submit', (event) => {
          event.preventDefault();
          applyFilters();
        }, { signal });
        search?.addEventListener('input', applyFilters, { signal });
        sort?.addEventListener('change', applyFilters, { signal });
        rating?.addEventListener('change', applyFilters, { signal });
        category?.addEventListener('change', applyFilters, { signal });
      }
    }

    customElements.define('hmc-reviews-ui', HmcReviewsUi);
  }

  } catch(e) { console.error(e); }
})();
})();
